/* ==========================================================================
   POPnBeats — mobile search usability fixes (behaviour)

   Loaded after main.js, so these handlers run after the theme's own.
   What it changes:
   - #btn-search no longer navigates to "#" (which jumped the page to the top).
   - The search field is focused inside the click gesture, so iOS/Android
     raise the keyboard immediately — no second tap needed.
   - Tapping anywhere on the blank overlay focuses the field, so a near-miss
     on the input still works.
   - Proper mobile keyboard: search type, "Search" enter key, no autocaps.
   - Escape closes; empty submits are ignored instead of loading /search?q=
   ========================================================================== */

(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  ready(function () {
    var overlay = document.querySelector('.form-search');
    if (!overlay) { return; }

    var input = overlay.querySelector('#engo_autocomplate') ||
                overlay.querySelector('input[name="q"]');
    var form = overlay.querySelector('form');
    var closeBtn = overlay.querySelector('#close-search');
    var results = overlay.querySelector('#productSearchResults');

    if (input) {
      // type=search gives a clear button and a "Search" key on the mobile
      // keyboard; the rest stops iOS auto-capitalising product searches.
      input.setAttribute('type', 'search');
      input.setAttribute('enterkeyhint', 'search');
      input.setAttribute('autocapitalize', 'off');
      input.setAttribute('autocorrect', 'off');
      input.setAttribute('autocomplete', 'off');
      input.setAttribute('spellcheck', 'false');
    }

    function focusInput() {
      if (!input) { return; }
      try { input.focus({ preventScroll: true }); }
      catch (err) { input.focus(); }
    }

    function openSearch(e) {
      if (e) { e.preventDefault(); }
      overlay.classList.add('pnb-search-open');
      overlay.style.right = '0px';
      document.body.classList.add('pnb-search-lock');
      // Must happen synchronously inside the user gesture or mobile Safari
      // refuses to raise the keyboard. The retry covers the case where the
      // overlay is still being painted on the first attempt.
      focusInput();
      setTimeout(function () {
        if (input && document.activeElement !== input) { focusInput(); }
      }, 80);
    }

    function closeSearch(e) {
      if (e) { e.preventDefault(); }
      overlay.classList.remove('pnb-search-open');
      overlay.style.right = '';
      document.body.classList.remove('pnb-search-lock');
      if (input) { input.blur(); }
      if (results) { results.style.display = 'none'; }
    }

    var openers = document.querySelectorAll('#btn-search, .btn-search');
    for (var i = 0; i < openers.length; i++) {
      openers[i].addEventListener('click', openSearch);
    }

    if (closeBtn) { closeBtn.addEventListener('click', closeSearch); }

    // A near-miss anywhere on the blank overlay still lands on the field.
    overlay.addEventListener('click', function (ev) {
      var t = ev.target;
      if (!input || t === input) { return; }
      if (t.closest && (t.closest('a') || t.closest('button') ||
                        t.closest('#close-search') ||
                        t.closest('#productSearchResults'))) { return; }
      focusInput();
    });

    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape' && overlay.classList.contains('pnb-search-open')) {
        closeSearch();
      }
    });

    if (form) {
      form.addEventListener('submit', function (ev) {
        if (input && !input.value.trim()) {
          ev.preventDefault();
          focusInput();
        }
      });
    }
  });
})();
